
/**
 * ATTENTION! This file is auto-generated for the 'filemanager' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

/* eslint-disable @typescript-eslint/no-unused-vars */
import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcClient } from '@ayocore/platform/server/rpc/types';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { UploadedFileRepository } from '../server/repositories/UploadedFileRepository';
import type { UploadedFileLnkRepository } from '../server/repositories/UploadedFileLnkRepository';
import type { FileCategoryRepository } from '../server/repositories/FileCategoryRepository';
import type { FolderRepository } from '../server/repositories/FolderRepository';
import type { DriveEntryRepository } from '../server/repositories/DriveEntryRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","meta","getInstance","columns","filters"];

type UploadedFileRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<UploadedFileRepository>;
export function useUploadedFileRepository(): UploadedFileRepositoryClient { return makeRepositoryProxy<UploadedFileRepositoryClient>('filemanager::UploadedFileRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useUploadedFileRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const uploadedFileRepository = useUploadedFileRepository();

type UploadedFileLnkRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<UploadedFileLnkRepository>;
export function useUploadedFileLnkRepository(): UploadedFileLnkRepositoryClient { return makeRepositoryProxy<UploadedFileLnkRepositoryClient>('filemanager::UploadedFileLnkRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useUploadedFileLnkRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const uploadedFileLnkRepository = useUploadedFileLnkRepository();

type FileCategoryRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<FileCategoryRepository>;
export function useFileCategoryRepository(): FileCategoryRepositoryClient { return makeRepositoryProxy<FileCategoryRepositoryClient>('filemanager::FileCategoryRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useFileCategoryRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const fileCategoryRepository = useFileCategoryRepository();

type FolderRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<FolderRepository>;
export function useFolderRepository(): FolderRepositoryClient { return makeRepositoryProxy<FolderRepositoryClient>('filemanager::FolderRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useFolderRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const folderRepository = useFolderRepository();

type DriveEntryRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DriveEntryRepository>;
export function useDriveEntryRepository(): DriveEntryRepositoryClient { return makeRepositoryProxy<DriveEntryRepositoryClient>('filemanager::DriveEntryRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDriveEntryRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const driveEntryRepository = useDriveEntryRepository();

type getFileUrlsType = typeof import('../server/functions/getFileUrls').getFileUrls;
export const getFileUrls: RpcFunctionClient<getFileUrlsType> = makeFunctionProxy<getFileUrlsType>('filemanager::getFileUrls');
